<div class="page-banner" [ngStyle]=" {'background-image': 'url(' + IMG_HOST + banner.rutaImagen + ')' }">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="bannerContainerStyles">
                    <h2>Vinculación</h2>
                    <h3 class="h4">sociedad</h3>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="blog-area pt-100 pb-70">
    <div class="container">
        <div *ngIf="cargandoContenido">
            <i class='bx bx-loader-circle'></i> Cargando...
        </div>
        <div *ngIf="!cargandoContenido && contenido.contenido !=''" class="row">
            <div class="row h5 text-center p-md-5 p-4 stylesTextVSC mx-auto" [innerHtml]="contenido.contenido | safeHtml"></div>
        </div>
        <div *ngIf="cargandoSociedades">
            <i class='bx bx-loader-circle'></i> Cargando...
        </div>
        <div *ngIf="sinSociedades && !cargandoSociedades" style="text-align: center;">
            <h1><i class='bx bx-wrench'></i></h1>
            <h3>Sin contenido</h3>
        </div>
        <br><br>
        <div *ngIf="!sinSociedades && !cargandoSociedades" class="row">
            <div *ngFor="let sociedad of sociedades" class="d-flex">
                <div class="blog-card shadow d-flex flex-md-row flex-column border">
                    <div class="width-custome"> 
                    <img loading="lazy" [src]="IMG_HOST + sociedad.rutaImagen" alt="image" class="aspect-ratio-customeVS">
                    </div>
                    <div class="blog-text widthCustomeVS">
                        <div class="date">{{sociedad.fecha | date:'dd/MM/yyyy'}}</div>
                        <h3 class="">
                            {{sociedad.titulo}}
                        </h3>
                        <!-- -------------pendiente------------------- -->
                        <p class="mb-20" [innerHtml]="sociedad.contenido | truncate : 250 : true ">
                        </p>
                        <a [routerLink]="['/detalle-sociedad', sociedad.idSociedad]" class="default-btn-two">Leer
                            más</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
